import { useCallback, useEffect, useRef, useState } from 'react';
import { EMPTY_PREVIEW, HuddlePreview } from './HuddlePreview';
import type { HuddleDeviceSource } from './HuddleMedia';
import type { HuddleCameraPreferences } from './HuddleCamera';

export function useHuddlePreview() {
  const [state, setState] = useState(EMPTY_PREVIEW);
  const controller = useRef<HuddlePreview | null>(null);
  const getController = useCallback(() => controller.current ?? (controller.current = new HuddlePreview(setState)), []);
  const start = useCallback((source: HuddleDeviceSource, deviceId?: string, cameraPreferences?: HuddleCameraPreferences) => getController().start(source, deviceId, cameraPreferences), [getController]);
  const updateCamera = useCallback((preferences: HuddleCameraPreferences) => getController().updateCamera(preferences), [getController]);
  const stop = useCallback((source: HuddleDeviceSource) => controller.current?.stop(source), []);
  const stopAll = useCallback(() => controller.current?.stopAll(), []);
  const refreshDevices = useCallback(() => getController().refreshDevices(), [getController]);
  useEffect(() => () => { controller.current?.dispose(); controller.current = null; }, []);
  return { state, start, stop, stopAll, refreshDevices, updateCamera };
}
